<div class="row mt-4 no-gutters">
  <div class="col-12">
    <!-- New Summary-->
    <div class="row mt-3 bg-light no-gutters mx-0 py-2">

      <!-- <div class="col-lg-1 col-md-1 col-2 my-auto px-1"> -->
      <div class="col-lg-1 col-md-1 col-1 my-auto px-1">
        <!-- <img class="logo-14" src="{{getVehicleLogo(vehicleData)}}" alt="{{vehicleData.vin}}" /> -->
        <img class="logo-14" src="{{getVehicleLogo(vehicleData)}}" alt="logo" />
      </div>

      <!-- <div class="col-lg-3 col-md-3 col-3"> -->
      <div class="col-lg-3 col-md-3 col-3">
        <div class="font14-700">
          {{vehicleData.make}}&nbsp;{{vehicleData.model}}&nbsp;
          <span
            [ngClass]="{'ACTIVE':'badge-success', 'ENROLLED':'badge-success', 'INACTIVE':'badge-danger', 'PROVISIONED':'badge-warning',
                          'PENDING':'badge-warning', 'ASSIGNED':'badge-warning', 'ORDERED':'badge-danger', 'DELIVERED':'badge-danger', 'DELETED':'badge-danger'}[vehicleData.status]"
            class="badge badge-pill badge-400">{{vehicleData.status | customText}}</span>
        </div>

        <div *ngIf="showAccount && vehicleData.account && vehicleData.account.name" class="font13-400">
          {{ vehicleData.account.name }}
        </div>

        <div *ngIf="vehicleSummaryDate">
          <span class="font13-400">{{vehicleSummaryDate.key}}:&nbsp;</span>
          <span *ngIf="vehicleSummaryDate.value" class="font13-600">{{vehicleSummaryDate.value | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormatHHMM : utilService.countryData.timezone}}</span>
        </div>

        <!-- <div *ngIf="vehicleData && vehicleData.status == 'DELETED' && vehicleData.createdDate">
          <span class="font13-400">Onboarding Date:&nbsp;</span>
          <span class="font13-600">{{vehicleData.createdDate | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</span>
        </div> -->

        <div class="w-break font13-400">
          <span *ngIf="(vehicleData.enrollmentStatus=='ENROLLMENT_IN_PROGRESS' || vehicleData.enrollmentStatus=='ENROLLMENT_INITIATED')" class="font13-600">Enrollment in Progess</span>
          <span *ngIf="(vehicleData.enrollmentStatus=='NOT_ENROLLED' || vehicleData.enrollmentStatus=='ENROLLMENT_CANCELED')" class="font13-600">Not Enrolled</span>
          <span *ngIf="vehicleData.enrollmentStatus=='NOT_APPLICABLE'" class="font13-600">Enrollment Not Applicable</span>
          <!-- <div *ngIf="vehicleData.deviceStatus && ['DEALER', 'CORPORATE'].includes(account.category)"><span class="font13-600">Dongle Status : </span><span class="font13-400">{{vehicleData.deviceStatus|customText}}</span></div> -->
          <div *ngIf="showVehicleDeviceStatus()"><span class="font13-600">Dongle Status : </span><span class="font13-400">{{vehicleData.deviceStatus|customText}}</span></div>
        </div>

      </div>

      <!-- <div class="col-lg-2 col-md-2 col-2 text-center"> -->
      <div class="col-lg-4 col-md-4 col-4 text-left">
        <div class="font13-400">Color</div>
        <div class="font13-600 mt-1">{{vehicleData.color | customText}}</div>
      </div>

      <!-- <div class="col-lg-3 col-md-2 col-2 text-center"> -->
      <div class="col-lg-4 col-md-4 col-4 text-left">
        <div class="font13-400"><span *ngIf="vehicleData.trimName">Trim / </span>Year Built</div>
        <div class="font13-600 mt-1"><span *ngIf="vehicleData.trimName">{{vehicleData.trimName}} /
          </span>{{vehicleData.year}}</div>
      </div>

      <!-- <div class="col-lg-3 col-md-4 col-3">
          <div class="row no-gutters">
            <div class="col-9 font13-400">
              Location Assigned
            </div>
            <div class="col-3 text-right">
              <small><i class="fas fa-times pointer px-2 text-secondary" (click)="closeClicked()" data-toggle="tooltip"
                data-placement="right" title="Close"></i></small>
            </div>
            <div class="col-12 mx-0">
              <div class="font13-600" *ngIf="location && location.homeLocation && location.homeLocation.address, else noLocation">
                <span *ngIf="location.homeLocation.address.name">{{location.homeLocation.address.name}}, </span>
                <span>{{location.homeLocation.address.street}}, </span>
                <div>{{location.homeLocation.address.city}}
                  {{location.homeLocation.address.state}}, {{location.homeLocation.address.zipCode}}</div>
              </div>
              <ng-template #noLocation><span class="font13-600">None</span></ng-template>
            </div>
          </div>
      </div> -->
    </div>
    <!-- New Summary end-->

    <!-- TCU Details -->
    <!-- Commented device detail 20220727 -->
    <!-- <div *ngIf="vehicleData && vehicleData.status != 'DELETED' && doesAccountSupportsDongle()">
      <app-tcu-detail [vehicleData]="vehicleData" (vehicleDetailEmitter)="vehicleDataUpdated($event)">
      </app-tcu-detail>
    </div> -->
  <!--   <app-tcu-detail [vehicleData]="vehicleData">
    </app-tcu-detail> -->

    <!--Package Services start-->
    <div class="row no-gutters">
      <div *ngIf="vehicleData && vehicleData.status != 'DELETED'">
      <div class="col-12 mt-4 pl-0"><b>Package Services</b></div>
      <div class="col-12 pl-0" *ngIf="servicePackageList && servicePackageList.length>0; else noServicePackage">
        <div class="table-responsive col-12 mt-3 pb-1 pl-0 pr-0">
          <table class="table table-striped tbl-scrollable">
            <thead class="thead-light">
              <tr>
                <td width="30%" class="table-header">Service Package</td>
                <td width="70%" class="table-header">Services</td>
              </tr>
            </thead>
            <tbody class="max-height-57">
              <ng-container *ngIf="servicePackageList && servicePackageList.length>0">
                <tr *ngFor="let servicePackage of servicePackageList; let i = index">
                  <td width="30%">
                    {{servicePackage.servicePackageName | customText}}
                  </td>
                  <td width="70%">

                    <div *ngFor="let service of servicePackage.services;">
                      {{service.name | customText}}
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
      <ng-template class="col-12" #noServicePackage>
        <div class="col-12 mt-2 font13-400 pl-0">
          Vehicle does not have any packages assigned.
        </div>
      </ng-template>
      </div>

      <!--Importent Dates-->
      <div class="col-12 mt-4 mb-3"><b>Vehicle History</b></div>
      <div *ngIf="vehicleDates && vehicleDates.length>0; else noVehicleDates" class="col-12 table-responsive">
        <table class="table tbl-scrollable">
          <tbody class="max-height-57">
            <tr *ngFor="let vehicleDate of vehicleDates; let i = index">
              <td>
                <span class="text-secondary">{{vehicleDate.key}} : </span>
                <span *ngIf="vehicleDate.value; else noDate">{{vehicleDate.value | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormatHHMM : utilService.countryData.timezone}}</span>
                <ng-template #noDate><span>-</span></ng-template>
              </td>
              <!-- <td width="30%">
                {{vehicleDate.key}}
              </td>
              <td width="70%">
                {{vehicleDate.value | date: utilService.countryData.dateFormat : utilService.countryData.timezone}}
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template class="col-12" #noVehicleDates>
        <div class="col-12 mb-3 font13-400">
          Vehicle history not available.
        </div>
      </ng-template>

      <div *ngIf="vehicleData && vehicleData.status == 'DELETED'">
        <div class="mt-2 mb-3"><b>Vehicle Events</b></div>
        <app-vehicle-history-event [account]="account" [vehicleData]="vehicleData"></app-vehicle-history-event>
      </div>

    </div>
  </div>
</div>